import formatDate from "../../../helpers/formatDate.ts";
import useTooltip from "../../../hooks/useTooltip.tsx";

type ArchivedIndicatorArgs = {
  archivedAt: string;
  archivedByName?: string | null;
  separatorBefore?: boolean;
};

// "archiviert" marker in the activity meta row (#5059) — same look and
// tooltip pattern as the "bearbeitet" UpdatedIndicator.
export default function ArchivedIndicator({
  archivedAt,
  archivedByName,
  separatorBefore,
}: ArchivedIndicatorArgs) {
  const tooltipRef = useTooltip<HTMLSpanElement>();

  return (
    <>
      {separatorBefore && <span className="separator">•</span>}
      <span
        ref={tooltipRef}
        className="text-muted leading-none text-sm"
        title={I18n.t("activity.archived_information", {
          archived_at: formatDate(new Date(archivedAt), "dd.MM.yyyy HH:mm"),
          archived_by:
            archivedByName || I18n.t("js.memberships.profile_deleted_tooltip"),
        })}
      >
        {I18n.t("js.activity.archived")}
      </span>
    </>
  );
}
